// import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// // import { InformationPopup, TermsModal } from '../../components';
// import {
//   Poster,
//   About,
//   BestSeasons,
//   Tags,
//   SpotsTimeline,
//   AdditionalNote,
// } from "./components";
// import BookTour from "../booking/bookTour";
// import ContactHelp from "../contact/ContactHelp";
// import { useDispatch, useSelector } from "react-redux";
// import { setSelectedPackage } from "../../redux/slices/packageSlice";
// import env from "../../config.json";
// import MapViewBidding from "../booking/components/MapViewBidding";
// import { setIsConfirmBooked } from "../../redux/slices/bookingSlice";
// // import { useSelector, useStore,useDispatch } from "react-redux";

// const API_KEY = env.GOOGLE_MAP_API_KEY;
// const PackageItinerary = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   // let initialRadius = 0;
//   // const [selectedPackage, setSelectedPackage] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);
//   const [additionalNote, setAdditionalNote] = useState(false);
//   const [isModalVisible, setModalVisible] = useState(false);
//   const [showConfirm, setShowConfirm] = useState(false);
//   const [searchingInProgress, setSearchingInProgress] = useState(false); // Track the state from BookTour
//   const [filteredRiders, setfilteredRiders] = useState([]);
//   const [searchRadius, setSearchRadius] = useState(0); // Initial radius of 5 km for example
//   // const [incrementByRadius, setIncrementByRadius] = useState(0); // If you need this as well
//   const dispatch = useDispatch();
//   const pickupLocation = useSelector((state) => state.pickupLocation);
//   const isConfirmBooked = useSelector(
//     (state) => state.bookingConfirm.isConfirmBooked
//   );
//   // const [pickupLocation, setPickupLocation] = useState({
//   //   latitude: null,
//   //   longitude: null,
//   //   title: "",
//   //   subtext: "",
//   //   place_id: "",
//   // });

//   // Get the package from Redux state
//   const selectedPackage = useSelector((state) => state.package.selectedPackage);
//   const incrementByRadius=1;

//   console.log("searchingInProgress in package iternary", searchingInProgress);
//   // useEffect(() => {
//   //   if (location.state?.selectedPackage) {
//   //     setSelectedPackage(location.state.selectedPackage);
//   //   }
//   //   setIsLoading(false);
//   // }, [location.state]);

//   const bookTourRef = useRef(null);
//   useEffect(() => {
//     if (location.state?.selectedPackage) {
//       dispatch(setSelectedPackage(location.state.selectedPackage));
//     }
//     setIsLoading(false);
//   }, [location.state, dispatch]);

//   const goToBookingScreen = () => {
//     navigate("/tour-package-booking", {
//       state: { selectedPackage },
//     });
//   };

//   const handleAccept = () => {
//     setAdditionalNote(false);
//     goToBookingScreen();
//   };

//   const handleDecline = () => {
//     setAdditionalNote(false);
//   };
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);
//   const cancelBack = () => {
//     setShowConfirm(false); // Close the confirmation modal without navigation
//   };
//   const confirmBack = () => {
//     if (bookTourRef.current) {
//       bookTourRef.current.handleCancel();   // Call the BookTour function
//       dispatch((setIsConfirmBooked(false)))
//     }
//     setShowConfirm(false);
//     // navigate(-1);
//   };
// //
//   // Handle back button confirmation only if SearchingInProgress is true
//   useEffect(() => {
//     const handleBackPress = (event) => {
//       event.preventDefault();
//       console.error("searchingInProgress", searchingInProgress);
//       if (searchingInProgress) {
//         setShowConfirm(true);
//         // window.history.pushState(null, "", window.location.pathname);  // Prevent navigation until confirmed
//       } else {
//         // navigate(-1);  // Navigate back only if confirmed
//       }
//     };

//     window.addEventListener("popstate", handleBackPress);

//     // Initial history state push
//     window.history.pushState(null, "", window.location.pathname);

//     return () => {
//       window.removeEventListener("popstate", handleBackPress);
//     };
//   }, [searchingInProgress, navigate]);
//   return (
//     <div className="bg-gray-100 p-4 mt-6 pt-10 flex justify-center">
//       {isLoading ? (
//         <div className="flex flex-col items-center justify-center h-screen">
//           <div className="loader border-t-4 border-blue-500 rounded-full w-12 h-12 animate-spin"></div>
//           <p className="mt-4 text-gray-700">Loading...</p>
//         </div>
//       ) : (
//         <div className="max-w-6xl w-full flex flex-col md:flex-row gap-6 mt-6">
//           {/* Left Main Content */}
//           <div className="w-full md:w-2/3">
//             {isConfirmBooked ? (
//               <MapViewBidding
//                 API_KEY={API_KEY}
//                 driversList={filteredRiders}
//                 radius={(searchRadius + incrementByRadius) * 1000}
//                 start={{
//                   latitude: pickupLocation?.latitude,
//                   longitude: pickupLocation?.longitude,
//                 }}
//               />
//             ) : (
//               <>
//                 <h2 className="text-2xl font-bold text-gray-800 mb-4 ">
//                   {selectedPackage?.detailTitle}
//                 </h2>
//                 <div className="flex flex-col md:flex-row md:items-center md:justify-between">
//                   {selectedPackage?.idealPrice > 10 && (
//                     <p className="text-gray-600 mb-2">
//                       Starting At ₹{selectedPackage.idealPrice}
//                     </p>
//                   )}
//                   <p className="text-gray-600 mb-2">
//                     {selectedPackage?.cityScope} - {selectedPackage?.listTitle}
//                   </p>
//                 </div>

//                 <Poster
//                   thumbnailImage={selectedPackage?.thumbnailImage}
//                   backgroundType={selectedPackage?.backgroundType}
//                   backgroundURL={selectedPackage?.backgroundURL}
//                   featureVideo={selectedPackage?.featureVideo}
//                   detailSubheading={selectedPackage?.detailSubheading}
//                 />

//                 <About
//                   aboutText={`${selectedPackage?.detailDescription_1}\n\n${selectedPackage?.detailDescription_2}`}
//                 />
//                 <BestSeasons bestSeasons={selectedPackage?.bestSeasons} />
//                 <Tags tags={selectedPackage?.tags} />
//                 <SpotsTimeline
//                   spotsListRaw={selectedPackage?.placesIncluded}
//                   detailHeading={selectedPackage?.detailHeading}
//                 />
//               </>
//             )}
//           </div>

//           {/* Right Sidebar (Always Visible) */}
//           <div className="w-full md:w-1/3 md:self-start md:sticky md:top-20 fixed bottom-0 left-0 shadow-lg md:p-0 md:relative overflow-y-auto max-h-[90vh]">
//             <BookTour
//              ref={bookTourRef}
//               id={selectedPackage?.id}
//               selectedPackageDetails={selectedPackage}
//               setSearchingInProgress={setSearchingInProgress}
//               setFilteredRiders={setfilteredRiders}
//               searchRadius={searchRadius}
//               setSearchRadius={setSearchRadius}
//               // incrementByRadius={incrementByRadius} // If needed
//               // setIncrementByRadius={setIncrementByRadius}
//             />
//           </div>
//         </div>
//       )}

//       <AdditionalNote
//         isVisible={additionalNote}
//         onDecline={handleDecline}
//         onAccept={handleAccept}
//         additionalNote={selectedPackage?.additionalNote}
//       />

//       {showConfirm && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//           <div className="bg-white p-6 rounded-lg shadow-lg w-96">
//             <h2 className="text-xl font-semibold">Confirm Navigation</h2>
//             <p className="mt-4">
//               Searching is in progress. Are you sure you want to leave this
//               page?
//             </p>
//             <div className="flex justify-end mt-6">
//               <button
//                 className="bg-gray-500 text-white px-4 py-2 rounded mr-2 hover:bg-gray-700"
//                 onClick={cancelBack}
//               >
//                 Cancel
//               </button>
//               <button
//                 className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-700"
//                 onClick={confirmBack}
//               >
//                 Confirm
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default PackageItinerary;

import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import {
  Poster,
  About,
  BestSeasons,
  Tags,
  SpotsTimeline,
  AdditionalNote,
} from "./components";
import BookTour from "../booking/bookTour";
import ContactHelp from "../contact/ContactHelp";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedPackage } from "../../redux/slices/packageSlice";
import env from "../../config.json";
import MapViewBidding from "../booking/components/MapViewBidding";
import { setIsConfirmBooked } from "../../redux/slices/bookingSlice";
import { TOUR_SLUGS } from "../../const/slugs";
import TourPackageServices from "../../services/externalServices/tourPackages/TourPackageServices";
import KeyFeatures from "./components/KeyFeatures";
import AudioBottomSheet from "./components/AudioBottomSheet";
import AppInstallPromo from "./components/AppInstallPromo";
import Slider from "./components/Slider";

const API_KEY = env.GOOGLE_MAP_API_KEY;

const PackageItinerary = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(true);
  const [additionalNote, setAdditionalNote] = useState(false);
  const [isModalVisible, setModalVisible] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [searchingInProgress, setSearchingInProgress] = useState(false);
  const [filteredRiders, setFilteredRiders] = useState([]);
  const [searchRadius, setSearchRadius] = useState(0);
  const [isCabrequestCancelled, setIsCabrequestCancelled] = useState(true);
  const [audioVisible, setAudioVisible] = useState(false);
  const [audioAvailable, setAudioAvailable] = useState(false);
  const [selectedAudioLang, setSelectedAudioLang] = useState("en");
  const [selectedAudioTitle, setSelectedAudioTitle] = useState("");
  const [selectedAudioDesc, setSelectedAudioDesc] = useState("");
  const [selectedAudioType, setSelectedAudioType] = useState("Package");
  const [selectedAudioImage, setSelectedAudioImage] = useState("");
  const [selectedAudioUrl, setSelectedAudioUrl] = useState("");
  const [selectedSubtitleUrl, setSelectedSubtitleUrl] = useState("");
  const [selectedAudioData, setSelectedAudioData] = useState([]); // Initialize as an empty array
  const [showAppPromo, setShowAppPromo] = useState(true);

  const pickupLocation = useSelector((state) => state.pickupLocation);
  const isConfirmBooked = useSelector(
    (state) => state.bookingConfirm.isConfirmBooked
  );
  const selectedPackage = useSelector((state) => state.package.selectedPackage);
  const incrementByRadius = 1;
  const { slug } = useParams();

  const bookTourRef = useRef(null);
  console.log("slug", slug);

  useEffect(() => {
    const packageId = TOUR_SLUGS[slug];
    console.log("packageId", packageId);
    const getpackageDetails = async () => {
      try {
        const res = await TourPackageServices.getPackageById(packageId);
        dispatch(setSelectedPackage(res));
        console.log("response from the package details by id", res);
      } catch (error) {
        console.log("error getting the package details by id", error);
      } finally {
        // ✅ Set loading to false ONLY after fetch is complete
        setIsLoading(false);
      }
    };

    getpackageDetails();
    // if (location.state?.selectedPackage) {
    //   // dispatch(setSelectedPackage(location.state.selectedPackage));
    // }
    // setIsLoading(false);
  }, [location.state, dispatch]);

  const goToBookingScreen = () => {
    navigate("/tour-package-booking", {
      state: { selectedPackage },
    });
  };

  const handleAccept = () => {
    setAdditionalNote(false);
    goToBookingScreen();
  };

  const handleDecline = () => {
    setAdditionalNote(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const cancelBack = () => {
    setShowConfirm(false);
  };

  const confirmBack = () => {
    if (bookTourRef.current) {
      bookTourRef.current.handleCancel();
      dispatch(setIsConfirmBooked(false));
      // dispatch(searchingInProgress(false));
      setSearchingInProgress(false);
      setIsCabrequestCancelled(false);
    }
    setShowConfirm(false);
  };

  // ✅ Handle Reload (beforeunload event)
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (searchingInProgress) {
        // Prevent the default reload confirmation dialog
        event.preventDefault();
        event.returnValue = ""; // For Chrome
        if (bookTourRef.current) {
          bookTourRef.current.handleCancel();
          dispatch(setIsConfirmBooked(false));
        }
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [searchingInProgress, dispatch]);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (searchingInProgress) {
        // Prevent the default reload confirmation dialog
        event.preventDefault();
        event.returnValue = ""; // For Chrome
        setShowConfirm(true);
        // setSearchingInProgress(false)
      }
    };

    window.addEventListener("popstate", handleBeforeUnload);

    // Initial history state push
    window.history.pushState(null, "", window.location.pathname);

    return () => {
      window.removeEventListener("popstate", handleBeforeUnload);
    };
  }, [searchingInProgress, dispatch]);

  const onOptAudioSelect = () => {
    console.log("onOptAudioSelect triggered.");
    console.log(
      "onOptAudioSelect triggered -> selectedPackage?.sampleAudioGuide ",
      selectedPackage?.sampleAudioGuide
    );
    console.log(
      "onOptAudioSelect triggered -> selectedAudioLang ",
      selectedAudioLang
    );

    const isAudioAvailable =
      selectedPackage &&
      typeof selectedPackage?.sampleAudioGuide.audioUrl === "string" &&
      selectedPackage?.sampleAudioGuide.audioUrl.trim() !== "" &&
      selectedPackage?.sampleAudioGuide.isEnabled;

    console.log("isAudioAvailable -> onOptAudioSelect -> ", isAudioAvailable);
    // console.log('audioData -> onOptAudioSelect -> ', audioData);

    setAudioAvailable(isAudioAvailable);

    setSelectedAudioTitle(selectedPackage?.detailTitle);
    setSelectedAudioDesc(selectedPackage?.sampleAudioGuide.name);
    setSelectedAudioType("Package");
    setSelectedAudioImage(selectedPackage?.thumbnailImage);
    setSelectedAudioData([]);

    if (isAudioAvailable) {
      setSelectedAudioUrl(selectedPackage?.sampleAudioGuide.audioUrl);
      setSelectedSubtitleUrl(selectedPackage?.sampleAudioGuide.subtitlesUrl);
    } else {
      setSelectedAudioUrl("");
      setSelectedSubtitleUrl("");
    }

    setAudioVisible(true);
  };

  return (
    <div className="bg-gray-100 p-4 mt-6 pt-10 flex justify-center">
      {isLoading ? (
        <div className="flex flex-col items-center justify-center h-screen">
          <div className="loader border-t-4 border-blue-500 rounded-full w-12 h-12 animate-spin"></div>
          <p className="mt-4 text-gray-700">Loading...</p>
        </div>
      ) : (
        <div className="max-w-6xl w-full flex flex-col md:flex-row gap-6 mt-6">
          <div className="w-full md:w-2/3">
            {isConfirmBooked ? (
              <MapViewBidding
                API_KEY={API_KEY}
                driversList={filteredRiders}
                radius={(searchRadius + incrementByRadius) * 1000}
                start={{
                  latitude: pickupLocation?.latitude,
                  longitude: pickupLocation?.longitude,
                }}
              />
            ) : (
              <>
                <h2 className="text-2xl font-bold text-gray-800 mb-4 ">
                  {selectedPackage?.detailTitle}
                </h2>
                <div className="flex flex-col md:flex-row md:items-center md:justify-between">
                  {selectedPackage?.idealPrice > 10 && (
                    <p className="text-gray-600 mb-2">
                      Starting At ₹{selectedPackage.idealPrice}
                    </p>
                  )}
                  <p className="text-gray-600 mb-2">
                    {selectedPackage?.cityScope} - {selectedPackage?.listTitle}
                  </p>
                </div>

                {/* <Poster
                  thumbnailImage={selectedPackage?.thumbnailImage}
                  backgroundType={selectedPackage?.backgroundType}
                  backgroundURL={selectedPackage?.backgroundURL}
                  featureVideo={selectedPackage?.featureVideo}
                  detailSubheading={selectedPackage?.detailSubheading}
                /> */}

                  {Array.isArray(selectedPackage?.sliderImages) &&
              selectedPackage.sliderImages.some(img => typeof img === 'string' && img.trim() !== '') ? (
              <Slider SliderImages={selectedPackage.sliderImages} />
            ) : (
              <Poster
                thumbnailImage={selectedPackage.thumbnailImage}
                backgroundType={selectedPackage.backgroundType}
                backgroundURL={selectedPackage.backgroundURL}
                featureVideo={selectedPackage.featureVideo}
                detailSubheading={selectedPackage.detailSubheading}
              />
            )}

                <About
                  aboutText={`${selectedPackage?.detailDescription_1}\n\n${selectedPackage?.detailDescription_2}`}
                />
                <BestSeasons bestSeasons={selectedPackage?.bestSeasons} />
                <Tags tags={selectedPackage?.tags} />
                <KeyFeatures
                  isEnabledAudioGuide={selectedPackage?.isEnabledAudioGuide}
                  onOptAudioSelect={onOptAudioSelect}
                />
                {showAppPromo&&(<AppInstallPromo
                    onClose={() => setShowAppPromo(false)} 
                    // showOnMobileOnly={true}
                />)}
                
                <SpotsTimeline
                  spotsListRaw={selectedPackage?.placesIncluded}
                  detailHeading={selectedPackage?.detailHeading}
                />

                <AudioBottomSheet
                  audioVisible={audioVisible}
                  onClose={() => setAudioVisible(false)}
                  audioProps={{
                    audioAvailable,
                    title: selectedAudioTitle,
                    description: selectedAudioDesc,
                    type: selectedAudioType,
                    thumbnailImage: selectedAudioImage,
                    audioUrl: selectedAudioUrl,
                    subtitleUrl: selectedSubtitleUrl,
                  }}
                />
              </>
            )}
          </div>

          {/* Right Sidebar */}
          <div className="w-full md:w-1/3 md:self-start md:sticky md:top-20 fixed bottom-0 left-0 shadow-lg md:p-0  overflow-y-auto max-h-[90vh]">
            {/* <div className="w-full md:w-1/3 md:self-start sticky top-20 md:relative overflow-y-auto max-h-[90vh]"> */}

            <BookTour
              ref={bookTourRef}
              id={selectedPackage?._id}
              selectedPackageDetails={selectedPackage}
              setSearchingInProgress={setSearchingInProgress}
              setFilteredRiders={setFilteredRiders}
              searchRadius={searchRadius}
              setSearchRadius={setSearchRadius}
              isCabrequestCancelled={isCabrequestCancelled}
              setIsCabrequestCancelled={setIsCabrequestCancelled}
            />
          </div>
        </div>
      )}

      <AdditionalNote
        isVisible={additionalNote}
        onDecline={handleDecline}
        onAccept={handleAccept}
        additionalNote={selectedPackage?.additionalNote}
      />

      {showConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96">
            <h2 className="text-xl font-semibold">Confirm Navigation</h2>
            <p className="mt-4">
              Searching is in progress. Are you sure you want to leave this
              page?
            </p>
            <div className="flex justify-end mt-6">
              <button
                className="bg-gray-500 text-white px-4 py-2 rounded mr-2 hover:bg-gray-700"
                onClick={cancelBack}
              >
                Cancel
              </button>
              <button
                className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-700"
                onClick={confirmBack}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PackageItinerary;
